import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Header from './Components/Header/Header';
import Players from './Components/Players/Players';

function App() {
  
  return (
    <div className="App">
      <Header></Header>
      <Players></Players>
    </div>
  );
}

export default App;
